module.exports = __webpack_public_path__ + "media/campaigns/confetti-dd3f1acf.gif";